import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M19 5A5 5 0 1 1 9 5a5 5 0 0 1 10 0Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M7.778 22.444c4.295 0 7.778-2.785 7.778-6.222 0-3.436-3.483-6.222-7.778-6.222C3.482 10 0 12.786 0 16.222c0 1.536.696 2.943 1.85 4.028L.777 24l4.042-2.021c.912.3 1.91.465 2.958.465ZM4 15.2v1.6h4.937L6.87 18.869 8 20l4-4-4-4-1.131 1.131L8.937 15.2H4Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M24 20h-8.108a6.692 6.692 0 0 0 1.164-3.778c0-1.606-.557-3.04-1.488-4.222h3.309a4 4 0 0 1 3.88 3.03L24 20Z"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }